var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPilotMechanicalEngineer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#7a756d;}.cls-3{fill:#3a3938;}.cls-4{fill:#565554;}.cls-5{fill:#e2e2e2;}.cls-6{fill:#2b2b2b;}.cls-7{fill:#0a0a0a;}.cls-8{fill:#594f43;}.cls-9{fill:#303030;}.cls-10{fill:#565759;}.cls-11{fill:#474747;}.cls-12{fill:#7c889b;}.cls-13{fill:#393a3a;}.cls-14{fill:#454647;}.cls-15{fill:#fff;mix-blend-mode:lighten;opacity:0.5;}.cls-16{fill:#ffd629;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "286.85 353 -7.84 353 -7.84 247.07 141.21 193 286.85 247.07 286.85 353"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "231 336 48 336 65 232 214 232 231 336"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 72,
    y: 191,
    width: 18,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 189,
    y: 191,
    width: 18,
    height: 53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "139.67 56.35 65.45 77.95 48.84 172.17 72.45 211.39 106.84 232 139.67 239.99 172.81 232.66 206.89 211.39 230.49 172.17 213.89 77.95 139.67 56.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "139.67 205.38 121.28 190 139.67 183.62 158.05 190 139.67 205.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "150.39 212.65 139.67 211.65 128.94 212.65 123.67 208 139.67 209 155.67 208 150.39 212.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.17 209 139.17 209 137.17 203 142.17 203 140.17 209"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "104.05 187.65 89.63 174.81 89.31 156.2 114.31 136.72 120.09 142.77 122.42 157.45 104.05 187.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.96 188 190.38 175.15 190.7 156.54 165.7 137.06 159.92 143.12 157.59 157.8 175.96 188"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "39 64.82 39 94.94 61.41 110 87.49 101.38 94.85 69.42 65.09 47 39 64.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "240.22 64.82 240.22 94.94 217.82 110 191.73 101.38 184.37 69.42 214.14 47 240.22 64.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "229.36 131.2 141.81 127.2 54.25 131.2 54.25 116.46 141.81 112.46 229.36 116.46 229.36 131.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "51.03 151.91 58.55 152.28 58.55 117.53 51.03 117.53 51.03 151.91"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 58.55,
    y: 116.46,
    width: 4.3,
    height: 35.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 220.76,
    y: 116.46,
    width: 4.3,
    height: 35.45,
    transform: "translate(445.82 268.37) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "50.95 116.98 50.61 123.98 83.34 108.42 196.83 108.42 232.74 123.98 233 116.98 190.06 88.5 87.55 88.5 50.95 116.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "232.74 117.04 203.85 100.97 84.86 100.97 50.61 117.04 86.32 11.69 100.32 4.55 180.99 4.55 197.03 11.69 232.74 117.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "170.13 47.23 180.09 47.23 174.4 18.77 170.13 17.35 170.13 47.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "111.8 47.23 101.83 47.23 107.53 18.77 111.8 17.35 111.8 47.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "172.98 37.27 108.95 37.27 111.8 17.35 170.13 17.35 172.98 37.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "180.09 47.23 101.83 47.23 108.95 37.27 172.98 37.27 180.09 47.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "198.75 100.91 233 116.98 197.29 11.63 183.29 4.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "160.17 37.27 150.21 37.27 121.75 17.35 131.72 17.35 160.17 37.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "100.67 4.49 86.67 11.63 50.95 116.98 85.21 100.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "232.58 151.91 225.06 152.28 225.06 117.53 232.58 117.53 232.58 151.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72 232 52 232 52 205 72 195 72 232"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "207 232 227 232 227 205 207 195 207 232"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "181 55 101 55 102 52 180 52 181 55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "181.91 62 99.91 62 100.91 59 180.91 59 181.91 62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 72.43,
    y: 254.93,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 84.54,
    y: 254.93,
    width: 7.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 96.64,
    y: 254.93,
    width: 20.36,
    height: 7.57
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotMechanicalEngineer);
export default __webpack_public_path__ + "static/media/pilot-mechanical-engineer.7abcb613b2aaa3bfd3e010b8105146c4.svg";
export { ForwardRef as ReactComponent };